import classNames from 'classnames'
import CommonIcon from 'CommonIcon'
import { InfoElement } from 'components'
import { selectChannelsType } from 'data/selectors'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { countryIdToString, countryShortNameToString, getDifferenceWithPrecision, getNumberWithCurrency } from 'utils'

import Box from '@mui/material/Box'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  flagWrapper: {
    marginRight: '0.2rem',
    minWidth: '1.3rem',
    width: '1.3rem',
  },
})

function RevenueWebsiteTableRow({ data, index, style }) {
  const classes = useStyles()
  const { t: translate } = useTranslation()
  const { dataSourceVisibility, showModal, stores, maxRevenue, totalRevenue } = data
  const channelsType = useSelector(selectChannelsType)
  const store = stores[index]
  const percentOfTotalRevenue = store.revenueCurrent ? Math.round((100 * store.revenueCurrentPLN) / totalRevenue) : 0
  const percentOfMaxRevenue = Math.round((100 * store.revenueCurrentPLN) / maxRevenue)
  const modalHandler = () => {
    showModal(store)
  }
  const showSmallLogo = ['group', 'saleTypes', 'countries'].includes(channelsType)
  const countryShortName = store.storeName.split(' ').pop()
  const fallbackCountryName = countryIdToString(store.countryId)
  const iconName = showSmallLogo ? store.storeChannel : countryShortNameToString(countryShortName, fallbackCountryName)

  return (
    <Box
      style={style}
      onClick={modalHandler}
      className={classNames('row cursor-pointer', { 'is-temporary-closed': store.temporaryClosed })}
    >
      <div className="row-wrapper flex-row">
        <div className="cell-bar" style={{ width: `${percentOfMaxRevenue}%` }} />

        <div className="cell-title flex-row">
          <div className={classes.flagWrapper}>
            <CommonIcon name={iconName} />
          </div>

          <span>
            {store.position}
            {store.storeName}
          </span>
        </div>

        <div className="cell-value">
          <span>
            {getNumberWithCurrency({
              currency: store.currency,
              number: store.revenueCurrent,
              precision: 0,
              translate,
            })}
          </span>
        </div>

        <div className="cell-difference">
          <InfoElement
            percentDifference={getDifferenceWithPrecision({
              handleNullCase: true,
              number: store.revenuePercent,
              translate,
            })}
          />
        </div>

        <div className="cell-contribution">
          <span>{percentOfTotalRevenue}%</span>
        </div>

        {dataSourceVisibility && <div className="cell-data-source">{store.dataSource}</div>}
      </div>
    </Box>
  )
}

RevenueWebsiteTableRow.propTypes = {
  data: PropTypes.shape({
    dataSourceVisibility: PropTypes.bool,
    maxRevenue: PropTypes.number,
    showModal: PropTypes.func,
    store: PropTypes.object,
    totalRevenue: PropTypes.number,
  }),
  index: PropTypes.number,
  style: PropTypes.object,
}

export default RevenueWebsiteTableRow
